import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ImportProductsComponent } from './import-products.component';

const routes: Routes = [
  // Module is lazy loaded, see app-routing.module.ts
  { path: '', component: ImportProductsComponent, data: { title: 'Import Products' } }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class ImportProductsRoutingModule { }
